import {queryClient} from 'app/react-query'
import {QueryClientProvider} from 'react-query'
import AppBar from '../home/header/AppBar'
import SignupModal from './SignupModal'
import SignupContextProvider from './SignupModal/SignUpContextProvider'

export default function SignUp() {
  return (
    <>
      <AppBar />
      <SignupContextProvider>
        <QueryClientProvider client={queryClient}>
          <SignupModal />
        </QueryClientProvider>
      </SignupContextProvider>
    </>
  )
}
